import { useEffect, useState } from 'react';

const MESSAGES = [
  'Acabamos de reservar una boda en Santa Rosa, CA.',
  'Se acaba de agendar una fecha en Rohnert Park, CA.',
  'Un cliente confirmó evento en Petaluma, CA.',
  'Se reservó sesión en Napa, CA.',
  'Nueva fecha agendada en Sonoma, CA.',
  'Acabamos de confirmar evento en Healdsburg, CA.',
  'Un cliente apartó fecha en Sebastopol, CA.',
  'Se reservó boda en San Francisco, CA.',
  'Nueva fecha en Oakland, CA.',
  'Un cliente confirmó evento en Sacramento, CA.',
  'Se acaba de reservar evento en Vallejo, CA.',
  'Nueva fecha en Fairfield, CA.',
  'Un cliente agendó sesión en Vacaville, CA.',
  'Acabamos de confirmar evento en Ukiah, CA.',
  'Se reservó fecha en Willits, CA.',
  'Nueva boda agendada en Fort Bragg, CA.',
  'Un cliente confirmó evento en San Rafael, CA.',
  'Se reservó fecha en Novato, CA.',
  'Acabamos de agendar una cita en Santa Rosa, CA.',
  'Un cliente agendó cita de consulta en Petaluma, CA.',
  'Nueva cita programada en Napa, CA.',
  'Se agendó cita en Sonoma, CA.',
  'Un cliente reservó cita en Rohnert Park, CA.',
  'Acabamos de confirmar cita en Healdsburg, CA.',
  'Nueva cita agendada en San Francisco, CA.',
  'Se programó cita en Sacramento, CA.',
  'Un cliente agendó cita en Oakland, CA.',
  'Nueva cita confirmada en Sebastopol, CA.',
  'Se reservó cita de consulta en Vallejo, CA.',
  'Acabamos de agendar cita en San Rafael, CA.',
  'Un cliente programó cita en Novato, CA.',
  'Nueva cita en Fairfield, CA.',
  'Se agendó cita de consulta en Vacaville, CA.',
  'Un cliente reservó cita en Ukiah, CA.',
];

function getRandomMessage() {
  const index = Math.floor(Math.random() * MESSAGES.length);
  return MESSAGES[index];
}

export function FakeBookingsSantaRosa() {
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    let hideTimeout: NodeJS.Timeout | null = null;
    let loopTimeout: NodeJS.Timeout | null = null;

    const cycle = () => {
      const next = getRandomMessage();
      setMessage(next);

      // mostrar ~8 segundos
      hideTimeout = setTimeout(() => {
        setMessage(null);
      }, 8000);

      // siguiente mensaje en ~22 segundos
      loopTimeout = setTimeout(cycle, 22000);
    };

    cycle();

    return () => {
      if (hideTimeout) clearTimeout(hideTimeout);
      if (loopTimeout) clearTimeout(loopTimeout);
    };
  }, []);

  if (!message) return null;

  return (
    <div
      className="fixed left-4 z-40 max-w-xs rounded-lg bg-gradient-to-r from-purple-600 to-pink-500 text-white px-4 py-3 text-sm shadow-2xl border border-pink-400/30"
      style={{ bottom: 'calc(72px + env(safe-area-inset-bottom, 0px))' }}
    >
      <span className="font-semibold">✨ {message.includes('cita') ? 'Cita agendada:' : 'Reserva reciente:'} </span>
      <span>{message}</span>
    </div>
  );
}
